<template>
    <div>
        <v-container id="regular-tables" fluid tag="section">
            <v-simple-table :dark="$store.state.isDarkMode">
                <thead class="table-heading" v-if="!meal.orderMealsState.loading">
                    <tr>
                        <th v-for="(name, i) in tableOptions.tableHeaders" :key="i">
                            {{ $t(name) }}
                        </th>
                    </tr>
                </thead>
                <div class="table__spinnerWrapper" v-if="meal.orderMealsState.loading">
                    <app-spinner></app-spinner>
                </div>
                <v-fade-transition mode="out-in" :group="true" tag="tbody">
                    <tr v-for="(item, idx) in tableOptions.tableData" :key="idx" v-show="!meal.orderMealsState.loading">
                        <td>
                            <!-- <img :src="item.image" alt=""> -->
                            <div class="d-flex flex-column justify-space-between align-center">
                                <v-img style="margin-top: 10px;margin-bottom: 10px;" :aspect-ratio="16 / 9" :width="100"
                                    :src="getImgUrl(item.meal.image)"></v-img>
                            </div>
                        </td>
                        <td>
                            <span>{{ item.meal.id }}</span>
                        </td>
                        <td>
                            {{ item.meal.name }}
                        </td>
                        <td>
                            {{ item.meal.price }}
                        </td>
                        <td>
                            {{ item.total }}
                        </td>
                        <td>
                            <v-icon color="red" style="cursor: pointer" class="px-2" @click="handleDisplay(item)">mdi-eye
                            </v-icon>
                        </td>
                    </tr>
                </v-fade-transition>
            </v-simple-table>
            <display-stu-meal v-if="this.item" v-model="display" :form="item"></display-stu-meal>
        </v-container>
    </div>
</template>
<script>
import displayStuMeal from "../../views/dashboard/orderedMeal/displayStuMeal.vue";
import spinner from "./spinner.vue";
import pagination from "./pagination.vue";
import editMeal from "../../views/dashboard/meal/editMeal.vue";
import deleteMeal from "../../views/dashboard/meal/deleteMeal.vue";
import { meal } from '../../store/auth'
export default {
    components: {
        displayStuMeal,
        appSpinner: spinner,
        appPagination: pagination,
        editMeal,
        deleteMeal,
    },
    data() {
        return {
            meal,
            deleteDialog: false,
        };
    },

    props: {
        serverRoute: String,
        enableDelete: {
            type: Boolean,
            default: true,
        },
        flaggedItems: {
            type: Array,
            default() {
                return [];
            },
        },
        displaySettings: {
            type: Boolean,
            default: true,
        },
        tableOptions: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    // computed: {
    //   ...mapGetters({
    //     tableOptions: "tablesStore/getTableOptions",
    //   }),
    // },
    methods: {
        handleDisplay(item) {
      this.item =item
      this.display = true
    },
        castItems(item) {
            let copyItem = { ...item };
            this.flaggedItems.forEach((el) => {
                delete copyItem[el];
            });
            return copyItem;
        },
        accessData(row, index) {
            return this.fetchAttributes(
                row,
                this.tableOptions.accessTableData[index]
            );
        },
        fetchAttributes(row, nestedKey) {
            let value = row;
            for (let key in nestedKey) {
                if (value[nestedKey[key]]) {
                    value = value[nestedKey[key]];
                } else {
                    return;
                }
            }
            return value.toLocaleString();
        },
        fetchNewPaginated(paginationValue) {
            this.$emit("re-fetch-paginated-data", paginationValue);
        },
        reFetchData() {
            this.$emit("re-fetch-data");
        },
        getImgUrl(item) {
            let domain = "https://ajyal-back.incentive-dev.com/"
            let item2 = item.replace("public", "storage")
            return domain + item2
        }
    },
};
</script>
  
<style ></style>